import HttpClient from './instance'

export const SEND_EMAILS = async (data = {}) =>
    HttpClient({
        method: 'post',
        url: '/admin/emails/send-emails',
        data,
    })
